/* POPELO shared behaviour (homepage + product). No dependencies, no globals.
   Re-inits on Shopify theme-editor section loads. Integrates with Horizon's
   cart drawer through the storefront standard events. */
(function () {
  'use strict';
  if (window.__popeloShared) return;
  window.__popeloShared = true;

  var CART_ADD = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart/add.js' : '/cart/add.js';
  var CART_GET = window.Shopify && Shopify.routes && Shopify.routes.root ? Shopify.routes.root + 'cart.js' : '/cart.js';

  function toSummary(cart) {
    return {
      id: cart.token || '',
      totalQuantity: cart.item_count,
      cost: { totalAmount: { amount: (cart.total_price / 100).toFixed(2), currencyCode: cart.currency } },
      lines: (cart.items || []).map(function (i) {
        return { id: i.key, quantity: i.quantity, cost: { totalAmount: { amount: (i.final_line_price / 100).toFixed(2), currencyCode: cart.currency } } };
      }),
      discountCodes: []
    };
  }

  function cartDrawerSectionId() {
    var drawer = document.querySelector('cart-drawer-component');
    var section = drawer && drawer.closest('.shopify-section');
    return section ? section.id.replace('shopify-section-', '') : null;
  }

  function swapSection(sectionId, html) {
    if (!sectionId || !html) return;
    var host = document.getElementById('shopify-section-' + sectionId);
    if (!host) return;
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.getElementById('shopify-section-' + sectionId);
    host.innerHTML = fresh ? fresh.innerHTML : html;
  }

  function openDrawer() {
    var drawer = document.querySelector('cart-drawer-component');
    var themeDrawer = drawer && drawer.closest('theme-drawer');
    if (themeDrawer && typeof themeDrawer.open === 'function' && !themeDrawer.isOpen) {
      try { themeDrawer.open(); } catch (e) {}
    }
  }

  function announce(msg) {
    var live = document.getElementById('popelo-live');
    if (!live) {
      live = document.createElement('div');
      live.id = 'popelo-live';
      live.setAttribute('aria-live', 'polite');
      live.setAttribute('role', 'status');
      live.style.cssText = 'position:absolute;width:1px;height:1px;overflow:hidden;clip:rect(0 0 0 0);white-space:nowrap;';
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = msg; }, 60);
  }

  /* Add to cart for any form[data-popelo-add]. Reads [name=id] and optional [name=quantity]. */
  function bindAddToCart(root) {
    var forms = root.querySelectorAll('form[data-popelo-add]');
    Array.prototype.forEach.call(forms, function (form) {
      if (form.dataset.popeloBound) return;
      form.dataset.popeloBound = '1';
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var idField = form.querySelector('[name="id"]');
        var qtyField = form.querySelector('[name="quantity"]');
        var quantity = qtyField ? (parseInt(qtyField.value, 10) || 1) : 1;
        var btn = form.querySelector('button[type="submit"], .popelo-add, .popelo-atc__btn');
        if (!idField || !idField.value) return;
        if (btn) { btn.setAttribute('aria-busy', 'true'); btn.disabled = true; }

        var sectionId = cartDrawerSectionId();
        var payload = { items: [{ id: idField.value, quantity: quantity }] };
        if (sectionId) { payload.sections = sectionId; payload.sections_url = window.location.pathname; }

        fetch(CART_ADD, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify(payload)
        })
          .then(function (r) { return r.json().then(function (d) { return { ok: r.ok, data: d }; }); })
          .then(function (res) {
            if (!res.ok) { announce(res.data && res.data.description ? res.data.description : 'Could not add to cart.'); return; }
            if (sectionId && res.data.sections) { swapSection(sectionId, res.data.sections[sectionId]); }
            return fetch(CART_GET).then(function (r) { return r.json(); }).then(function (cart) {
              var evt = new Event('shopify:cart:lines-update', { bubbles: true, cancelable: false });
              evt.action = 'add';
              evt.context = 'product';
              evt.lines = [{ merchandiseId: idField.value, quantity: quantity }];
              evt.promise = Promise.resolve({ cart: toSummary(cart), detail: {} });
              document.dispatchEvent(evt);
              openDrawer();
              announce('Added to cart.');
            });
          })
          .catch(function () { announce('Could not add to cart. Please try again.'); })
          .finally(function () { if (btn) { btn.removeAttribute('aria-busy'); btn.disabled = false; } });
      });
    });
  }

  function bindTabs(root) {
    var groups = root.querySelectorAll('[data-popelo-tabs]');
    Array.prototype.forEach.call(groups, function (group) {
      if (group.dataset.popeloBound) return;
      group.dataset.popeloBound = '1';
      var target = document.getElementById(group.getAttribute('data-popelo-tabs'));
      var tabs = group.querySelectorAll('[role="tab"]');
      Array.prototype.forEach.call(tabs, function (tab) {
        tab.addEventListener('click', function () {
          Array.prototype.forEach.call(tabs, function (t) { t.setAttribute('aria-selected', 'false'); });
          tab.setAttribute('aria-selected', 'true');
          var filter = tab.getAttribute('data-filter') || 'all';
          if (!target) return;
          Array.prototype.forEach.call(target.querySelectorAll('[data-category]'), function (card) {
            var cats = (card.getAttribute('data-category') || '').split(' ');
            card.hidden = !(filter === 'all' || cats.indexOf(filter) !== -1);
          });
        });
      });
    });
  }

  function bindFeatured(root) {
    var sections = root.querySelectorAll('[data-popelo-featured]');
    Array.prototype.forEach.call(sections, function (section) {
      if (section.dataset.popeloBound) return;
      section.dataset.popeloBound = '1';
      var img = section.querySelector('[data-featured-img]');
      var name = section.querySelector('[data-featured-name]');
      var desc = section.querySelector('[data-featured-desc]');
      var cta = section.querySelector('[data-featured-cta]');
      var swatches = section.querySelectorAll('[data-swatch]');
      function pick(sw) {
        Array.prototype.forEach.call(swatches, function (s) { s.setAttribute('aria-pressed', 'false'); });
        sw.setAttribute('aria-pressed', 'true');
        if (sw.dataset.bg) section.style.setProperty('--pop-bg', sw.dataset.bg);
        if (sw.dataset.ink) section.style.setProperty('--pop-ink', sw.dataset.ink);
        if (img && sw.dataset.img) { img.src = sw.dataset.img; img.alt = sw.dataset.name || ''; }
        if (name && sw.dataset.name) name.textContent = sw.dataset.name;
        if (desc && sw.dataset.desc) desc.textContent = sw.dataset.desc;
        if (cta && sw.dataset.url) { cta.href = sw.dataset.url; }
      }
      Array.prototype.forEach.call(swatches, function (sw) { sw.addEventListener('click', function () { pick(sw); }); });
    });
  }

  function init(root) {
    root = root || document;
    if (!root.querySelectorAll) return;
    bindAddToCart(root);
    bindTabs(root);
    bindFeatured(root);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    var t = e.target;
    if (t && t.getAttribute && t.getAttribute('role') === 'tab') { t.click(); }
    if (t && t.hasAttribute && t.hasAttribute('data-swatch')) { t.click(); }
  });
})();
